<template>
	<div>
		<ag-grid-vue style="width: 100%; height: 750px" class="ag-theme-alpine" :animateRows="true"
			:suppressCopyRowsToClipboard="true" :defaultColDef="defaultColDef" :columnDefs="cariListColumn" :rowData="cariList"
			:localeText="localeText" :pagination="true" @grid-ready="onGridReady">
		</ag-grid-vue>

	</div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import TextGorunumCellRenderer from "./CellRenderer/TextGorunumCellRenderer.vue";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
export default {
	data() {
		return {
			localeText: null,
			cariListColumn: [],
			defaultColDef: {
				sortable: true,
				resizable: true
			},
			checkSelected: "",
			cariList: [],
			dir: false,
			columns: [
				{
					label: "Cari Kodu",
					field: "CARI_KOD",
				},
				{
					label: "Cari Adı",
					field: "CARI_UNVAN",
				},
				{
					label: "Telefon",
					field: "CARI_TEL",
				},

				{
					label: "Adres",
					field: "adres",
				},
				{
					label: "Vergi",
					field: "VERGIDAIRESI",
				},
				{
					label: "Bakiye",
					field: "BAKIYE",
				},
			],
		};
	},
	components: { AgGridVue, TextGorunumCellRenderer },
	methods: {
		onGridReady(params) {
			this.gridApi = params.api;
			this.gridColumnApi = params.columnApi;
		},
		selectionChanged() { },
		cariListGet() {
			var vm = this;
			const soap = require("soap");
			const url = state.sistemAddress;
			const args = {
				token: Store.state.tokenId,
			};
			soap.createClient(url, function (err, client) {
				client.B2B_LS_Cari(args, function (err, result) {
					if (result.B2B_LS_CariResult == "-1") {
						Store.dispatch("logout");
						//this.$store.dispatch('login', payload)
					}


					vm.veriler = JSON.parse(result.B2B_LS_CariResult);
					vm.cariList = vm.veriler;


					let columnList = Object.keys(vm.cariList[0]);
					vm.cariListColumn = [];

					columnList.forEach((val, index) => {

						vm.cariListColumn.push({
							field: val,
							filter: "agSetColumnFilter",
							wrapText: true,
							autoHeight: true,
							cellClass: "textType",
							cellRenderer: "TextGorunumCellRenderer",
						});

					});
					// if (vm.veriler != "") vm.KAYITSAYISI = vm.veriler[0].KAYITSAYISI;
				});
			});
		},
	},
	created() {
		this.cariListGet();
		this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
	},
};
</script>
<style lang="scss">
table.vgt-table {
	font-size: small;
}
</style>